import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const subspaceActionsPopupEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(/* webpackChunkName: "async-subspace-action-popup" */ './SubspaceActionsPopup.tsx'),
	),
	getPreloadProps: () => ({}),
});
